import React, { useState } from "react";

export const NotificationContext = React.createContext();

function NotificationProvider({ children }) {
  const [triggerNotify, setTriggerNotify] = useState(false);

  const value = React.useMemo(() => {
    return {
      triggerNotify,
      setTriggerNotify,
    };
  }, [triggerNotify, setTriggerNotify]);

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
}

export default NotificationProvider;
